import { useEffect, useCallback, useState } from 'react';
import { useAuth } from './useAuth';

/**
 * Hook for listening to realtime custom events triggered by GlobalStateProvider
 */
export const useRealtimeSync = (eventType: 'profile' | 'membership' | 'listings' | 'all' = 'all') => {
  const [lastUpdate, setLastUpdate] = useState<Date | null>(null);
  const { user } = useAuth();

  const handleProfileUpdate = useCallback((event: Event) => {
    const customEvent = event as CustomEvent;
    console.log('Profile update received:', customEvent.detail);
    setLastUpdate(new Date());
  }, []);

  const handleMembershipUpdate = useCallback((event: Event) => {
    const customEvent = event as CustomEvent;
    console.log('Membership update received:', customEvent.detail);
    setLastUpdate(new Date());
  }, []);

  const handleListingsUpdate = useCallback((event: Event) => {
    const customEvent = event as CustomEvent;
    console.log('Listings update received:', customEvent.detail);
    setLastUpdate(new Date());
  }, []);

  useEffect(() => {
    if (!user) return;

    const events: string[] = [];

    if (eventType === 'all' || eventType === 'profile') {
      window.addEventListener('profile-updated', handleProfileUpdate);
      events.push('profile-updated');
    }

    if (eventType === 'all' || eventType === 'membership') {
      window.addEventListener('membership-updated', handleMembershipUpdate);
      events.push('membership-updated');
    }

    if (eventType === 'all' || eventType === 'listings') {
      window.addEventListener('listings-updated', handleListingsUpdate);
      events.push('listings-updated');
    }

    return () => {
      events.forEach(eventName => {
        if (eventName === 'profile-updated') {
          window.removeEventListener('profile-updated', handleProfileUpdate);
        } else if (eventName === 'membership-updated') {
          window.removeEventListener('membership-updated', handleMembershipUpdate);
        } else if (eventName === 'listings-updated') {
          window.removeEventListener('listings-updated', handleListingsUpdate);
        }
      });
    };
  }, [user, eventType, handleProfileUpdate, handleMembershipUpdate, handleListingsUpdate]);

  return { lastUpdate };
};
